// =============================================
// TREE REGISTRY - All available decision trees
// =============================================

// Tree definitions for the dashboard
export const treeRegistry = [
  {
    id: "location",
    title: "Where Should I Live?",
    description: "A branching decision tree for location decisions based on mission and visibility.",
    category: "Life Decisions",
    gates: 6
  },
  {
    id: "launch",
    title: "Should I Launch While Rebuilding?",
    description: "A linear decision tree for evaluating launch readiness during uncertain times.",
    category: "Business Decisions",
    gates: 7
  },
  {
    id: "spending",
    title: "Should I Spend This Money?",
    description: "A zone-based resource rules system. Select your cash zone, then walk through the gates for any non-essential purchase.",
    category: "Resource Rules",
    gates: "5+"
  },
  {
    id: "mini",
    title: "Binary Game Introduction",
    description: "A 5-gate introductory tree that demonstrates the Binary Game decision framework.",
    category: "Introduction",
    gates: 5
  }
];

export default treeRegistry;
